const actions = {
    GET_PINCODE_LIST:'GET_PINCODE_LIST',
    SET_PINCODE_LIST:'SET_PINCODE_LIST',
    GET_MONTHWISE_SALES_COUNT: 'GET_MONTHWISE_SALES_COUNT',
    SET_MONTHWISE_SALES_COUNT: 'SET_MONTHWISE_SALES_COUNT',
    UPDATE_VENDOR_ACTIVE: 'UPDATE_VENDOR_ACTIVE',
  };
  
  export default actions;